export const DELETE_CREATIVE_MODAL_TEXT = 'Are you sure you want to delete this creative?';

export const RESTORE_CREATIVE_MODAL_TEXT = 'Are you sure you want to restore this creative?';
